import React, { memo } from 'react';
import { withStyles, Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles';

const EquipmentStatusCounter = memo(({ counter, classes }) => (
  <div className={classes.statusCounterWrapper}>
    <Tooltip
      title="Quantidade de equipamentos por grupo"
      placement="top-start"
      classes={{ tooltip: classes.multilineTooltip }}
    >
      <div className={classes.statusCounterItemsContainer}>
        <div
          className={classNames(
            classes.statusCounterItem,
            classes.effectiveMode,
          )}
        >
          {counter.effectiveMode}
        </div>
        <div
          className={classNames(
            classes.statusCounterItem,
            classes.operationalStopMode,
          )}
        >
          {counter.operationalStopMode}
        </div>
        <div
          className={classNames(
            classes.statusCounterItem,
            classes.maintenanceMode,
          )}
        >
          {counter.maintenanceMode}
        </div>
      </div>
    </Tooltip>
  </div>
));

export default withStyles(styles)(EquipmentStatusCounter);

EquipmentStatusCounter.propTypes = {
  classes: PropTypes.object.isRequired,
  counter: PropTypes.shape({
    effectiveMode: PropTypes.number,
    operationalStopMode: PropTypes.number,
    maintenanceMode: PropTypes.number,
  }),
};

EquipmentStatusCounter.defaultProps = {
  counter: {
    effectiveMode: 0,
    operationalStopMode: 0,
    maintenanceMode: 0,
  },
};
